import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';
import CommonService from '@/services/CommonService';
import { PURGE_AUTH } from '@/store/mutation-types';

export const status = {
  HTTP_BAD_REQUEST: 400,
  HTTP_UNAUTHORIZED: 401,
  HTTP_FORBIDDEN: 403,
  HTTP_NOT_FOUND: 404,
  HTTP_INTERNAL_SERVER_ERROR: 500,
};

export default (inline = false, contentType = 'application/json', noEncoding = false) => {
  const token = store.state.auth.token;
  const currentProfile = store.state.auth.user;
  const apiUrl = process.env.VUE_APP_API_URL
    ? process.env.VUE_APP_API_URL
    : ('https://' + location.host + '/api');

  const headers = {
    'Accept': 'application/json',
    'Content-Type': contentType,
    'X-Language': CommonService.currentLanguage()
  };
  
  if(token && token !== '' && token !== 'undefined') {
    headers['X-W-Auth'] = CommonService.generateJWT(store.state.auth.bearer, token)
  }

  if (currentProfile && typeof (currentProfile.id) !== 'undefined') {
    headers['X-Profile-Id'] = currentProfile.id;
  }

  let responseHeader = {
                        baseURL: apiUrl,
                        withCredentials: false,
                        headers: headers,
                       };
  // set reponse download PDF
  if(noEncoding == true){
      responseHeader.responseType = 'arraybuffer';
      responseHeader.responseEncoding = 'binary';
  };

  const axiosInstance = axios.create(responseHeader);

/*
  axiosInstance.interceptors.request.use(function (config) {
    return config;
  });
*/
  axiosInstance.interceptors.response.use((response) => {
    return response;
  }, (error) => {

    if (error.message == 'Network Error') {
      let data = {
        error: "Network Error",
        code: 500
      };
      return false;
    }
    const logoutCodes = [
      status.HTTP_UNAUTHORIZED,
      status.HTTP_FORBIDDEN
    ];
    const loginEndpoints = [
      `${apiUrl}/auth/token`,
      `${apiUrl}/auth`
    ]
    console.log(error.config.url)
    console.log(loginEndpoints)
    if (logoutCodes.indexOf(error.response.status) !== -1
        && loginEndpoints.indexOf(error.config.url) === -1
    ) {

      store.commit(PURGE_AUTH);
      router.push({name: 'login'})
    }

    if (inline) {
      return Promise.reject(error.response.data);
    }

    return false;
  });

  return axiosInstance;
};
